export default __webpack_public_path__ + "static/media/job_vacancies.0f6b47c0.less";